import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Spinner } from "reactstrap";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import AuthProtected from "./AuthProtected";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";

const Index = () => {
  const LoadingFallback = () => <Spinner color="primary" />;

  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route: any, idx: any) => (
            <Route
              path={route.path}
              element={
                <NonAuthLayout>
                  <Suspense>
                    {/*fallback={<LoadingFallback />} */}
                    {route.component}
                  </Suspense>
                </NonAuthLayout>
              }
              key={`public-routes-${route.component}@${idx}`}
              // exact={true}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected allowedRoles={route.allowedRoles}>
                  <VerticalLayout>
                    <Suspense>
                      {/*fallback={<LoadingFallback />} */}
                      {route.component}
                    </Suspense>
                  </VerticalLayout>
                </AuthProtected>
              }
              key={`auth-protected-routes-${route.component}@${idx}`}
              // exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
